import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { V_URL } from "../../../BaseUrl";
import toast from "react-hot-toast";

export const createStoreQuotation = createAsyncThunk('/quotation/create-store-quotation',
    async (payload) => {
        try {
            const myurl = `${V_URL}/prosafe/quotation/create-store-quotation`;

            const response = await axios({
                method: 'post',
                url: myurl,
                data: payload,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem('PAY_USER_TOKEN')
                },
            });
            const data = response?.data;
            if (data.success === true) {
                toast.success(response?.data?.message || "Quotation Inquery Submitted Successfully");
                return data;
            } else {
                toast.error(response?.data?.message || "Something went wrong");
                throw new Error(response?.data?.message || "Something went wrong");
            }
        } catch (error) {
            toast.error("something went wrong");
            return error;
        }
    })

const createStoreQuotationSlice = createSlice({
    name: "createStoreQuotation",
    initialState: {
        user: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(createStoreQuotation.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(createStoreQuotation.fulfilled, (state, action) => {
                state.user = action.payload;
                state.loading = false;
                state.error = null;
            })
            .addCase(createStoreQuotation.rejected, (state, action) => {
                state.user = null;
                state.loading = false;
                state.error = action.error.message;
            });
    }
})

export default createStoreQuotationSlice.reducer;